import React, { FC } from 'react';

import { Grid } from '@chakra-ui/react';

import { MetadataCommonFields } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/Components/MetadataCommonFields';
import { useActiveResourceContext } from 'containers/ActiveCloudResource/hooks/context/context';

import {
  AgentConnected,
  Agent,
  CapacityProviderName,
  Allocation,
  DockerVersion,
  Ports,
  RegisteredAt,
  RunningPendingTasks,
  VirtualMachineInstanceID,
} from '../../../../Components/MetadataField/MetaGridFields';

export const ECSContainerInstanceMetadata: FC = () => {
  const { resourceDetails } = useActiveResourceContext();
  const { data: resource } = resourceDetails;

  return (
    <Grid templateColumns="repeat(4, 1fr)" gap={4}>
      <MetadataCommonFields arn={resource} />
      {VirtualMachineInstanceID(resource)}
      {CapacityProviderName(resource)}
      {Allocation(resource)}
      {Ports(resource)}
      {AgentConnected(resource)}
      {Agent(resource)}
      {DockerVersion(resource)}
      {RunningPendingTasks(resource)}
      {RegisteredAt(resource)}
    </Grid>
  );
};
